import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Brand } from "@/components/layout/Brand";
import { Button } from "@/components/ui/button";
import { ThemeToggle } from "@/components/layout/ThemeToggle";
import { Container } from "@/components/layout/Container";
import { PageTransition } from "@/components/motion/PageTransition";
import { AITutorSheet } from "@/components/chat/AITutorSheet";
import { FloatingAITutorButton } from "@/components/chat/FloatingAITutorButton";
import { TextSelectionPopup } from "@/components/chat/TextSelectionPopup";

export function StudyShell() {
  const navigate = useNavigate();
  const location = useLocation();
  const isCompactPdfRoute = /\/study\/[^/]+\/(textbook|notes|question-bank)$/.test(location.pathname);
  // A timed, graded test is not a place to surface "ask the AI tutor" --
  // that would just be an answer-lookup shortcut. Every other immersive
  // viewer keeps the FAB; only the exam-mode take page suppresses it.
  const isExamRoute = /\/tests\/[^/]+\/take$/.test(location.pathname);
  return (
    <div className="min-h-screen min-h-[100dvh] flex flex-col bg-bg text-text w-full">
      {!isCompactPdfRoute ? (
        <header className="sticky top-0 z-30 border-b border-border bg-bg/80 backdrop-blur">
          <Container size="full" className="flex h-14 items-center justify-between">
            <div className="flex items-center gap-2">
              <Button variant="ghost" size="icon" onClick={() => navigate(-1)} aria-label="Back">
                <ArrowLeft className="h-[1.1rem] w-[1.1rem]" />
              </Button>
              <Link to="/dashboard" className="hidden sm:inline">
                <Brand to="/dashboard" />
              </Link>
            </div>
            <ThemeToggle />
          </Container>
        </header>
      ) : null}
      <main className="flex-1">
        <PageTransition>
          <Outlet />
        </PageTransition>
      </main>

      {/* AI Tutor surface -- mounted once for the whole study experience.
          The FAB summons the sheet from any viewer; the selection popup
          lets users highlight text in PDFs/summaries and ask about it.
          Suppressed during a timed test -- see isExamRoute above. */}
      {!isExamRoute ? (
        <>
          <FloatingAITutorButton />
          <AITutorSheet />
          <TextSelectionPopup />
        </>
      ) : null}
    </div>
  );
}
